
$(document).ready(function(){
$(".bfilter-menu").click(function(e) {
  var selectSize = $(this).attr('data-text');
$('.filter-title').html(" / " + selectSize);

filter(selectSize)
  e.preventDefault();  
  
});

function filter(e) {
  var regex = new RegExp('\\b' + e + '\\b');
  console.log('test', regex)
  $('.size').hide().removeClass('show_tr').filter(function() {
    console.log($(this).data('size'), regex.test($(this).data('size')))
    return regex.test($(this).data('size'))
  }).show().addClass('show_tr');
  
  setTimeout(function(){        			
  var numItems = $('.show_tr').length;
  $('.brand-count').html(numItems);
  }, 100);
  
  
}












});


jQuery(function($) {
$('#data-tables .tr_row:lt(11)').addClass('active');
if($('#data-tables .tr_row:last-child').hasClass('active')){
	 $('.loadmore').addClass('hide');	
	 }	
  $('a.loadmore').on('click', function(e) {
    e.preventDefault();
    var $rows = $('#data-tables .tr_row');    
    var lastActiveIndex = $rows.index($rows.filter('.active').last());    
    $rows.filter(':lt(' + (lastActiveIndex + 50) + ')').addClass('active');
    // hide the button when all elements visible
	if($('#data-tables .tr_row:last-child').hasClass('active')){
	 $('.loadmore').addClass('hide');	
	 }	
  });
});